import * as React from 'react'

export const mutedButton = (
  <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" id="svg2">
  <defs id="defs11">
     <mask maskUnits="userSpaceOnUse" id="mask4258">
        <g id="g4260">
           <rect y="0" x="2" height="24" width="22" style={{fill:"#ffffff"}} />
           <path d="m 21.5,2 -16,20" style={{stroke: "#000000", strokeWidth: 2}}>
        </path>
        </g>
     </mask>
  </defs>
  <circle style={{opacity: 0.7, fill: "#0f171e"}} r="20" cy="20" cx="20" id="Oval" />
  <g style={{fill: "#ffffff"}} transform="translate(8,8)" id="icon/unmuted" mask="url(#mask4258)">
     <path id="Fill-1" d="m 4.5488,9 c -0.303,0 -0.549,0.247 -0.549,0.549 l 0,4.902 c 0,0.303 0.246,0.549 0.549,0.549 l 3.451,0 c 0.184,0 0.363,0.051 0.521,0.146 l 6.479,3.949 0,-14.392 -6.461,4.139 C 8.3788,8.945 8.1918,9 7.9998,9 l -3.451,0 z m 11.451,12.875 c -0.18,0 -0.36,-0.049 -0.52,-0.146 L 7.7198,17 4.5488,17 c -1.405,0 -2.549,-1.144 -2.549,-2.549 l 0,-4.902 C 1.9998,8.144 3.1438,7 4.5488,7 l 3.158,0 7.754,-4.967 c 0.31,-0.198 0.699,-0.21 1.019,-0.035 0.321,0.175 0.52,0.511 0.52,0.877 l 0,18 c 0,0.361 -0.195,0.695 -0.511,0.872 -0.151,0.085 -0.32,0.128 -0.489,0.128 l 0,0 z" />
     <path id="Fill-3" d="m 19,19 c -0.256,0 -0.512,-0.098 -0.707,-0.293 -0.39,-0.389 -0.391,-1.019 -0.004,-1.41 C 18.375,17.207 20,15.472 20,12 20,8.509 18.357,6.774 18.287,6.702 17.905,6.307 17.91,5.676 18.301,5.29 18.695,4.903 19.32,4.906 19.707,5.293 19.801,5.387 22,7.636 22,12 22,16.364 19.801,18.613 19.707,18.707 19.512,18.902 19.256,19 19,19" />
  </g>
  <path style={{stroke: "#ffffff", strokeWidth: 2, strokeLinecap: "round"}} d="M 27,10 11,30">
  </path>
</svg>

)

export const unmutedButton = (
  <svg width="40px" height="40px" viewBox="0 0 40 40">
    <g id="icon/sound-on" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill="#0F171E" opacity="0.7" cx="20" cy="20" r="20" />
      <g id="icon/unmuted" transform="translate(8.000000, 8.000000)" fill="#FFFFFF">
        <path d="M4.5488,9 C4.2458,9 3.9998,9.247 3.9998,9.549 L3.9998,14.451 C3.9998,14.754 4.2458,15 4.5488,15 L7.9998,15 C8.1838,15 8.3628,15.051 8.5208,15.146 L14.9998,19.095 L14.9998,4.703 L8.5388,8.842 C8.3788,8.945 8.1918,9 7.9998,9 L4.5488,9 Z M15.9998,21.875 C15.8198,21.875 15.6398,21.826 15.4798,21.729 L7.7198,17 L4.5488,17 C3.1438,17 1.9998,15.856 1.9998,14.451 L1.9998,9.549 C1.9998,8.144 3.1438,7 4.5488,7 L7.7068,7 L15.4608,2.033 C15.7708,1.835 16.1598,1.823 16.4798,1.998 C16.8008,2.173 16.9998,2.509 16.9998,2.875 L16.9998,20.875 C16.9998,21.236 16.8048,21.57 16.4888,21.747 C16.3378,21.832 16.1688,21.875 15.9998,21.875 L15.9998,21.875 Z" id="Fill-1" />
        <path d="M19,19 C18.744,19 18.488,18.902 18.293,18.707 C17.903,18.318 17.902,17.688 18.289,17.297 C18.375,17.207 20,15.472 20,12 C20,8.509 18.357,6.774 18.287,6.702 C17.905,6.307 17.91,5.676 18.301,5.29 C18.695,4.903 19.32,4.906 19.707,5.293 C19.801,5.387 22,7.636 22,12 C22,16.364 19.801,18.613 19.707,18.707 C19.512,18.902 19.256,19 19,19" id="Fill-3" />
      </g>
    </g>
  </svg>
)

export const fullscreenButton = (
  <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1">
    <g id="fullscreen-button" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" >
        <circle id="Oval" fill="#0F171E" opacity="0.7" cx="20" cy="20" r="20" />
        <g id="fullscreen" fill="#FFFFFF" transform="translate(7.5, 7.5)">
            <path d="M24.969,0.002 L24.969,0.002 L24.969,0 L21.969,0 L21.969,0.002 L15.969,0 L15.969,3 L19.723,3 L13.852,8.871 L15.973,10.992 L21.969,4.996 L21.969,9 L24.969,9 L24.969,2.25 L24.969,0.002 L24.969,0.002 Z" id="Shape_1_"></path>
            <path d="M9,22 L5.246,22 L11.117,16.129 L8.996,14.008 L3,20.004 L3,16 L0,16 L0,22.75 L0,25 L3,25 L9,25 L9,22 L9,22 Z" id="Shape_2_"></path>
        </g>
    </g>
</svg>
)

export const exitFullscreenButton = (
  <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1">
    <g id="exit-fullscreen" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill="#0F171E" opacity="0.7" cx="20" cy="20" r="20" />
      <g id="exit-fullscreen" fill="#FFFFFF" transform="translate(5, 7)">
          <path d="M9.984,15 L3.984,15 L3.985,18 L7.738,18 L0.867,24.871 L2.989,26.992 L9.984,19.996 L9.984,24 L12.984,24 L12.984,17.25 L12.984,15.001 L9.984,15 Z" id="Shape_1_"></path>
          <path d="M21.262,9 L28.133,2.129 L26.012,0.008 L19.016,7.004 L19.016,3 L16.016,3 L16.016,9.75 L16.016,11.999 L19.016,12 L25.016,12 L25.016,9 L21.262,9 Z" id="Shape_2_"></path>
      </g>
    </g>
</svg>
)
